import { AppType, BackendAppType, ViewableAppType } from './app.type';
import { IntegrationConfigConfig } from './config-types/integration-config-config.type';
import * as ss from 'superstruct';
import { OauthProvider } from '../oauth';
import { RlClientConfig } from './config-types/rl-client.type';
import { UPSClientConfig } from './config-types/ups-client-config.type';
import { TwilioVoiceConfig } from './config-types/twilio-voice-config.type';

/**
 * If the AppType has a configuration object associated with it,
 * associate that object with the AppType in this map.
 *
 * The configuration object gets stored in the app_config table.
 *
 * The app_config table is defined in app-config.entity.ts
 */
const AppTypeConfigMapProps = {
  [ViewableAppType.IntegrationConfig]: IntegrationConfigConfig,
  [BackendAppType.RlClient]: RlClientConfig,
  [BackendAppType.UPSClient]: UPSClientConfig,
  [BackendAppType.TwilioVoice]: TwilioVoiceConfig,
  // No config of its own.
  [BackendAppType.TestReducer]: ss.literal(undefined),
} as const satisfies Record<AppType, ss.Struct<any, any>>;

export const AppTypeConfigMap = ss.type(AppTypeConfigMapProps);

export type AppTypeConfigMap = ss.Infer<typeof AppTypeConfigMap>;

export const OrgAppConfig = ss.partial(AppTypeConfigMapProps);

export type OrgAppConfig = ss.Infer<typeof OrgAppConfig>;

export const fakeOrgAppConfig = (): OrgAppConfig => ({
  [ViewableAppType.IntegrationConfig]: {
    enabledOauthIntegrations: [OauthProvider.Intuit],
  },
});
